import React from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const NotFoundPage = ({ showLink, text = 'Page not found' }) => (
  <Box className='py-6 px-8'>
    <Typography align='center' variant='h1' className='text-secondary'>404</Typography> 
    <Typography color='primary' align='center' variant='h6'>{text}</Typography> 
    {showLink && (
      <Link 
        to='/'
        className='absolute bottom-4 text-small text-clickeable' 
      >
        Back to Dashboard
      </Link> 
    )}
  </Box>
)
export default NotFoundPage
